module.exports = __webpack_public_path__ + "static/ir-7c8e6cb3156702fe6be30d30425a2a87.svg";